export default "__VITE_ASSET__fc1dd627__"